// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-assembly/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springAssemblyEN: PageEntry = {
  id: "post.federmontage",
  locale: "en",
  slug: "spring-assembly",
  seo: {
    title: "Glossary: Spring assembly explained simply | Dietz GmbH",
    description: "Spring assembly refers to the process of installing or attaching springs in a mechanical system. This step is critical to ensure that the spring is properly positioned and secured.",
  },
  type: "post",
  h1: "Glossary: Spring assembly explained simply",
  intro: "Spring assembly refers to the process of installing or attaching springs in a mechanical system. This step is critical to ensure that the spring is properly positioned and secured. Spring assembly requires precise handling and alignment to ensure optimal spring function. In various applications, from industrial machinery to vehicles, correct spring assembly plays a key role in the performance and reliability of the overall system.",
  blocks: [

  ],
};
